import { render, staticRenderFns } from "./GoogleRedirectTo.vue?vue&type=template&id=15bba9a6&scoped=true"
import script from "./GoogleRedirectTo.vue?vue&type=script&lang=js"
export * from "./GoogleRedirectTo.vue?vue&type=script&lang=js"
import style0 from "./GoogleRedirectTo.vue?vue&type=style&index=0&id=15bba9a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bba9a6",
  null
  
)

export default component.exports